module.exports = __webpack_public_path__ + "static/img/case_8.17e271c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_8.jpg
// module id = xunG
// module chunks = 0